var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSurveyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.417)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.83,26.007l-1.189-.493a8.6,8.6,0,0,0-.687-1.72l.5-1.224a1.2,1.2,0,0,0-.165-1.224c-.176-.221-.366-.433-.571-.651-.2-.2-.4-.4-.61-.575a1.1,1.1,0,0,0-1.185-.179l-1.179.523a7.9,7.9,0,0,0-1.656-.714l-.476-1.238a1.153,1.153,0,0,0-.944-.74,8.36,8.36,0,0,0-.844-.04V4.433a3.113,3.113,0,0,0-3.049-3.167h-6.1L16.369,1.3A1.837,1.837,0,0,0,14.633,0H12.194a1.853,1.853,0,0,0-1.738,1.267H3.049A3.113,3.113,0,0,0,0,4.433V32.3a3.113,3.113,0,0,0,3.049,3.167H20.388c.052.048.1.1.155.146a1.1,1.1,0,0,0,1.185.179l1.179-.522a7.936,7.936,0,0,0,1.656.713l.476,1.238a1.155,1.155,0,0,0,.944.741,8.335,8.335,0,0,0,.845.039,8.083,8.083,0,0,0,.838-.039,1.156,1.156,0,0,0,.952-.744l.475-1.235a7.936,7.936,0,0,0,1.656-.713l1.178.522A1.091,1.091,0,0,0,33.1,35.62c.213-.183.417-.38.627-.593s.384-.419.554-.633a1.208,1.208,0,0,0,.172-1.231l-.5-1.224a8.6,8.6,0,0,0,.687-1.72l1.191-.495a1.188,1.188,0,0,0,.713-.98c.025-.266.038-.553.038-.878s-.013-.612-.038-.87a1.19,1.19,0,0,0-.716-.988ZM23.779,2.533a1.866,1.866,0,0,1,1.829,1.9v13.46a1.185,1.185,0,0,0-.571.623l-.475,1.235c-.061.018-.115.044-.174.063V5.067A1.244,1.244,0,0,0,23.169,3.8H18.9V2.533Zm-3.232,17.58c-.213.183-.417.38-.627.593s-.384.419-.554.633a1.208,1.208,0,0,0-.172,1.231l.5,1.224a8.6,8.6,0,0,0-.687,1.72l-1.191.495a1.187,1.187,0,0,0-.713.98c-.025.264-.038.551-.038.878s.013.614.037.871a1.191,1.191,0,0,0,.716.989l1.189.493a8.558,8.558,0,0,0,.56,1.446H3.658V5.067H8.1a1.208,1.208,0,0,0,1.05.633h8.536a1.208,1.208,0,0,0,1.05-.633h4.438V20.33c-.087.046-.177.082-.263.132l-1.178-.522a1.09,1.09,0,0,0-1.178.174ZM10.457,2.533A1.207,1.207,0,0,0,11.615,1.7a.612.612,0,0,1,.579-.435h2.439a.612.612,0,0,1,.579.435,1.207,1.207,0,0,0,1.159.832h1.311v1.9H9.146v-1.9ZM1.219,32.3V4.433a1.866,1.866,0,0,1,1.829-1.9H7.926V3.8H3.658A1.244,1.244,0,0,0,2.439,5.067v26.6a1.244,1.244,0,0,0,1.219,1.267H19.293l-.095.23A1.21,1.21,0,0,0,19.25,34.2H3.049A1.866,1.866,0,0,1,1.219,32.3Zm34.117-3.737-1.432.595a.626.626,0,0,0-.366.436,7.288,7.288,0,0,1-.788,1.974.655.655,0,0,0-.039.576l.607,1.475c-.146.179-.3.351-.449.51s-.325.322-.5.478l-1.42-.63a.59.59,0,0,0-.554.041,6.728,6.728,0,0,1-1.9.819.618.618,0,0,0-.419.38L27.5,36.7a7.134,7.134,0,0,1-1.346,0l-.573-1.487a.618.618,0,0,0-.419-.38,6.729,6.729,0,0,1-1.9-.819.59.59,0,0,0-.554-.041l-1.42.63c-.173-.151-.338-.312-.491-.467s-.31-.338-.46-.521l.607-1.475a.655.655,0,0,0-.039-.576,7.288,7.288,0,0,1-.788-1.974.626.626,0,0,0-.366-.436l-1.429-.6c-.02-.231-.027-.464-.027-.7s.007-.463.027-.7l1.432-.595a.626.626,0,0,0,.366-.436,7.288,7.288,0,0,1,.788-1.974.655.655,0,0,0,.039-.576l-.607-1.475c.146-.179.3-.352.449-.51s.325-.322.5-.478l1.42.63a.59.59,0,0,0,.554-.041,6.729,6.729,0,0,1,1.9-.819.618.618,0,0,0,.419-.38l.573-1.487a7.03,7.03,0,0,1,1.346,0l.573,1.487a.618.618,0,0,0,.419.38,6.729,6.729,0,0,1,1.9.819.59.59,0,0,0,.554.041l1.42-.63c.173.151.338.312.491.467s.31.338.46.521l-.607,1.475a.655.655,0,0,0,.039.576,7.288,7.288,0,0,1,.788,1.974.626.626,0,0,0,.366.436l1.432.595c.02.233.027.466.027.7S35.357,28.329,35.336,28.563Z",
    fill: "#063269",
    stroke: "#063269",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.487,35a5.488,5.488,0,1,0,5.488,5.488A5.488,5.488,0,0,0,40.487,35Zm0,9.756a4.268,4.268,0,1,1,4.268-4.268A4.268,4.268,0,0,1,40.487,44.756Z",
    transform: "translate(-13.66 -12.243)",
    fill: "#063269",
    stroke: "#063269",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.268,13H9.219A1.219,1.219,0,0,0,8,14.219v3.049a1.219,1.219,0,0,0,1.219,1.219h3.049a1.219,1.219,0,0,0,1.219-1.219V14.219A1.219,1.219,0,0,0,12.268,13ZM9.219,17.268V14.219h3.049v3.049Z",
    transform: "translate(-3.122 -4.712)",
    fill: "#063269",
    stroke: "#063269",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.268,25H9.219A1.219,1.219,0,0,0,8,26.219v3.049a1.219,1.219,0,0,0,1.219,1.219h3.049a1.219,1.219,0,0,0,1.219-1.219V26.219A1.219,1.219,0,0,0,12.268,25ZM9.219,29.268V26.219h3.049v3.049Z",
    transform: "translate(-3.122 -9.063)",
    fill: "#063269",
    stroke: "#063269",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.268,37H9.219A1.219,1.219,0,0,0,8,38.219v3.049a1.219,1.219,0,0,0,1.219,1.219h3.049a1.219,1.219,0,0,0,1.219-1.219V38.219A1.219,1.219,0,0,0,12.268,37ZM9.219,41.268V38.219h3.049v3.049Z",
    transform: "translate(-3.122 -13.413)",
    fill: "#063269",
    stroke: "#063269",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.789,15.872a.61.61,0,0,0,.431.179h.061a.61.61,0,0,0,.447-.268l1.219-1.829a.61.61,0,0,0-1.015-.677l-.807,1.211-.084-.084a.61.61,0,1,0-.862.862Z",
    transform: "translate(-8.977 -4.741)",
    fill: "#063269",
    stroke: "#063269",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.365,20.61a.61.61,0,0,0-.61-.61H19.61a.61.61,0,0,0,0,1.219h9.146A.61.61,0,0,0,29.365,20.61Z",
    transform: "translate(-7.415 -7.317)",
    fill: "#063269",
    stroke: "#063269",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.22,28.05h.061a.61.61,0,0,0,.447-.268l1.219-1.829a.61.61,0,0,0-1.015-.677l-.807,1.211-.084-.084a.61.61,0,1,0-.862.862l.61.61A.61.61,0,0,0,24.22,28.05Z",
    transform: "translate(-8.977 -9.115)",
    fill: "#063269",
    stroke: "#063269",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.932,37.271l-.807,1.211-.084-.084a.61.61,0,1,0-.862.862l.61.61a.61.61,0,0,0,.431.179.417.417,0,0,0,.061,0,.61.61,0,0,0,.447-.268l1.219-1.829a.61.61,0,1,0-1.015-.677Z",
    transform: "translate(-8.976 -13.487)",
    fill: "#063269",
    stroke: "#063269",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1,32H19.61a.61.61,0,0,0,0,1.219H25.1A.61.61,0,0,0,25.1,32Z",
    transform: "translate(-7.415 -11.707)",
    fill: "#063269",
    stroke: "#063269",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.658,44H19.61a.61.61,0,0,0,0,1.219h3.049a.61.61,0,0,0,0-1.219Z",
    transform: "translate(-7.415 -16.098)",
    fill: "#063269",
    stroke: "#063269",
    strokeWidth: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyIcon);
export default __webpack_public_path__ + "static/media/survey-icon.a86c69ef1af9956e88c2849b8ffb62b7.svg";
export { ForwardRef as ReactComponent };